import axios from 'axios';
import type { InternalAxiosRequestConfig, AxiosResponse } from 'axios';
import { useAuthStore } from '@/store/auth';

const apiURL = import.meta.env.VITE_API_URL;

const request = axios.create({
  baseURL: apiURL,
  timeout: 5000, // 请求超时时间
});

// 请求拦截器
request.interceptors.request.use(
  (config: InternalAxiosRequestConfig<any>) => {
    const authStore = useAuthStore();
    const token = authStore.token;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
request.interceptors.response.use(
  (response: AxiosResponse<any>) => {
    const { errorCode, data, errorMessage } = response.data;
    if (errorCode === 0) {
      return data;
    } else if (String(errorCode) === '401') {
      useAuthStore().clearToken();
      return Promise.reject({
        message: errorMessage || '登录已过期，请重新登录',
      });
    } else {
      return Promise.reject({
        message: errorMessage || '请求失败',
      });
    }
  },
  (error) => {
    console.error('Response Error:', error);
    return Promise.reject(error);
  }
);

export default request;
